/** @file Field check for a stored-object id of one prefix (`pup_<26 Crockford base32>`, std `isId`). */
import { isId } from '@zilo/pose3d-std/ids/isId';
import type { IdPrefix } from '@zilo/pose3d-std/ids/idPrefixes';
import { failField } from '@zilo/pose3d-format/validate/fields/failField';
import type { FieldCheck } from '@zilo/pose3d-format/validate/fields/fieldCheck';

/** Check for an id with `prefix`. */
export function checkId(prefix: IdPrefix): FieldCheck {
  return (value, path) => {
    if (!isId(value, prefix)) failField(path, `${prefix}_ followed by 26 Crockford base32 characters`, value);
  };
}
